import {AnyAction, Reducer} from 'redux';
import {AuthorPollResponse, CommonUtils, StoreActionsEnum} from '../../../modules/hbs-services';

export const pollReducer: Reducer<AuthorPollResponse> = (state = null, action: AnyAction = null) => {

    switch (action.type) {

        case StoreActionsEnum.ENTIRE_POLL_LOADED:
        case StoreActionsEnum.POLL_INSERTED:
            return {record: action.payload.btPoll} as AuthorPollResponse;

        case StoreActionsEnum.BTPOLL_LOADED:
            if (action.payload.poll && action.payload.poll['_isValidation']) {
                return state;
            }
            return action.payload.poll as AuthorPollResponse;

        case StoreActionsEnum.POLL_PUBLISHED: {
            const newPoll = CommonUtils.jsonClone<AuthorPollResponse>(state);
            if (newPoll && newPoll.record) {
                newPoll.record.publishedFlag = true;
            }
            return newPoll;
        }

        case StoreActionsEnum.POLL_UNPUBLISHED: {
            const newPoll = CommonUtils.jsonClone<AuthorPollResponse>(state);
            if (newPoll && newPoll.record) {
                newPoll.record.publishedFlag = false;
            }
            return newPoll;
        }

        case StoreActionsEnum.POLL_DELETED:
        case StoreActionsEnum.RESET_POLL:
            return null;

        default:
            return state;
    }
};
